<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      灵芝站<br>
站点介绍<br>
车站位于前进一路和创业二路的交叉口路口，沿前进一路南北向敷设。车站设置有6个出入口，其中A1口为主要紧急出入口，有盲道及垂直电梯通往站厅，B口为备用紧急出入口。A2口为左炮台东方向公交接驳口，C2口为海上田园东方向公交接驳口。 车站装修风格融入线网“阳光+”的理念，打造温暖、舒适的公共交通空间。新丝路：12号线以结合 “一带一路”中“新海上丝绸之路”的概念和“粤港澳”大湾区的发展战略，12号线自身在深圳西部规划发展寓意着发展和未来。以阳光光照的“线”为提取元素，构造成“丝”“脉”“网” 丝：创新精神，生态海滨；脉：创新生活，东官新语；网：创新科技，海湾筑梦。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:57	5号线	3分钟	5分25秒<br>
黄贝岭	06:23	23:24	5号线	3分钟	5分25秒<br>
左炮台东	06:31	23:27	12号线	4分钟	8分钟<br>
海上田园东	06:20	23:44	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	23:56	5号线	4分钟	6分钟<br>
黄贝岭	06:31	23:24	5号线	4分钟	6分钟<br>
左炮台东	06:35	23:27	12号线	8分钟	8分钟<br>
海上田园东	06:22	23:44	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	00:56	5号线	4分钟	6分钟<br>
黄贝岭	06:31	00:24	5号线	4分钟	6分钟<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A2出入口:<br>
前进一路南侧、新安湖小学、大富豪广场、中国建设银行<br><br>
C2出入口:<br>
前进一路北侧、新创业电子广场、金丰豪庭<br><br>
D出入口:<br>
前进一路北侧<br>
（暂未开通） E出入口:<br>
前进一路南侧、宝安中医院<br>
（暂未开通）F出入口:<br>
前进一路南侧、华丰世纪集团、宝安艺术城、宝民社区服务中心<br><br>
公交换乘信息<br><br>
1、C2出入口:<br>
公交站名： 公园路西一巷<br>
395、615、629、M197、M245、M250、M313、M349、M393、M425、M518、高峰专线102、高峰专线138<br><br>
2、F出入口:<br>
公交站名： 灵芝地铁站<br>
E23、M197、M249、M371、M378、M395、M518、高峰专线102、M250、高峰专线56、高快巴士33<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "wuhaoxian",
            title: "5号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>